<template>
    <v-sheet>
        <v-row>
            <v-col>
                <v-row>
                    <v-col>
                        <h4 class="text-h4">Primary Scheduling</h4>
                        <div class="text-subtitle-1" v-if="$refs.calendar">{{$refs.calendar.title}}</div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn @click="prev" depressed block>
                    <v-icon left>mdi-arrow-left-bold</v-icon>
                    previous
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn @click="next" depressed block>
                    <v-icon left>mdi-arrow-right-bold</v-icon>
                    next
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn depressed block @click="handleRefresh">
                    <v-icon left>mdi-refresh</v-icon>
                    refresh
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <!-- <v-col cols="12" md="3">
                <v-select
                    outlined
                    hide-details
                    dense
                    single-line
                    background-color="white"
                    label="Calendar Type"
                    v-model="type"
                    :items="types"
                    @change="fetchEvents">
                </v-select>
            </v-col> -->
            
            <!-- <v-col cols="12" md="3" v-if="type == 'category'">
                <v-select
                    outlined
                    hide-details
                    dense
                    single-line
                    background-color="white"
                    label="Category"
                    v-model="category"
                    :items="categoryList"
                    @change="mapEvents">
                    <template v-slot:item="{item}">
                        <div>
                            <v-icon left>{{item.icon}}</v-icon>
                            {{item.text}}
                        </div>
                    </template>
                    <template v-slot:selection="{item}">
                        <div>
                            <v-icon left>{{item.icon}}</v-icon>
                            {{item.text}}
                        </div>
                    </template>
                </v-select>
            </v-col> -->
            <!-- <v-col cols="12" md="3" v-if="singleDaySelected && this.authorizations.sales_scheduling.create">
                <v-btn color="primary" block @click="handleEventCreate">
                    <v-icon>mdi-plus</v-icon>
                    new scheduling
                </v-btn>
            </v-col> -->
        </v-row>
        <v-row>
            <v-col>
                <div class="py-2">
                    <div v-if="errors.length > 0" class="text-center pa-4">
                        <div class="mb-2 error--text" v-for="(e, i) in errors" :key="i">{{e}}</div>
                        <v-btn text @click="handleRefresh">
                            <v-icon left>mdi-refresh</v-icon>
                            Try Again
                        </v-btn>
                    </div>
                    <v-calendar
                        v-else
                        color="primary"
                        v-model="focus"
                        ref="calendar"
                        :type="type"
                        :categories="calendarCategory"
                        :weekdays="weekdays"
                        event-overlap-mode="stack"
                        category-show-all 
                        @change="handleCalendarChange"
                        :events="events"
                        @click:event="handleEventClick"
                        @click:date="viewDay">

                        <template v-slot:category="{category}">
                            <v-sheet class="d-flex justify-center">
                                <v-chip outlined class="ma-2 font-weight-bold" color="primary">
                                    <v-icon size="25" class="orange--text me-3">
                                        {{ categoryIcon }}
                                    </v-icon>
                                    {{category}}
                                </v-chip>
                            </v-sheet>
                        </template>
                    </v-calendar>
                </div>
            </v-col>
        </v-row>
        <v-dialog v-model="eventDisplayDialog" width="1024" scrollable persistent>
            <SchedulingEventDisplay
                v-if="eventDisplayDialog"
                :event-id="selectedEvent.id"
                @close="eventDisplayDialog = false"      
                @updated="handleRefresh"
            />
        </v-dialog>
        <!-- <v-dialog v-model="eventEditShown" width="700" scrollable persistent>
            <SchedulingEventEdit
                v-if="eventEditShown"
                :date="focus"
                :event-id="selectedEvent.id"
                @close="eventEditShown = false"
                @success="handleEventSubmit($event, 'success')"
                @error="handleEventSubmit($event, 'error')"
                @fatal="eventEditShown = false"
                />
        </v-dialog> -->
        <v-snackbar 
            :color="snackbar.color" 
            v-model="snackbar.display" 
            right 
            bottom>
            {{snackbar.text}}
        </v-snackbar>
        <v-overlay v-model="loading">
            <v-sheet color="white" class="pa-4" width="300" elevation="1" rounded>
                <v-progress-linear indeterminate color="primary"/>
                <div class="primary--text text-center mt-2">Please Wait ...</div>
            </v-sheet>
        </v-overlay>
    </v-sheet>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
// import SchedulingEventEdit from './../../components/Sales/SchedulingEventEdit';
import SchedulingEventDisplay from '../../components/Sales/SchedulingEventDisplay.vue';
import { getSalesSchedules } from './../../services/scheduling/schedule';
import { states } from './../../data/sales/scheduling/states';
import { formatNumber } from 'accounting';
import { map } from 'lodash';
import { getPumps } from '../../services/scheduling/pumps';

const NO_PUMP_LABEL = "Without Pump";

export default {
    name: "Scheduling",
    components: {
        // SchedulingEventEdit
        SchedulingEventDisplay
    },
    props: {
        initialDate: String,
        initialType: String,
    },
    data() {
        return {
            focus: this.initialDate,
            events: [],
            errors: [],
            selectedEvent: {},
            eventDisplayDialog: false,
            calendarRange: {start: "", end: ""},
            snackbar: {},
            weekdays: [0, 1, 2, 3, 4, 5, 6],
            types: [
                { text: "Day",   value: "day" },
                { text: "Week",  value: "week" },
                { text: "Month", value: "month" },
                // { text: "Category", value: "category" }
            ],
            pumps: [],
            type: this.initialType ? this.initialType : "month",
            loading: false,
            category: "pump",
            categoryList: [
                { text: "Pump", value: "pump", icon: "mdi-fire-truck" },
                { text: "Plant", value: "plant", icon: "mdi-factory" }
            ],
        }
    },
    computed: {
        ...mapState('authentication', ["authorizations"]),
        ...mapGetters('sales/plants', ['plants']),
        plantsNames() {
            return map(this.plants, 'name');
        },
        singleDaySelected() {
            return this.type === 'day' || this.type === 'category';
        },
        calendarCategory() {
            if(this.category == "pump") return this.pumps;
            if(this.category == "plant") return this.plantsNames;
            else return [] 
        },
        categoryIcon() {
            if(this.category == "pump") return "mdi-fire-truck";
            if(this.category == "plant") return "mdi-factory";
            return "mdi-circle";
        }
    },
    methods:{
        ...mapActions("sales/plants", {
            fetchPlants: "fetch"
        }),
        formatNumber,
        next() {
            this.$refs.calendar.next();
        },
        prev() {
            this.$refs.calendar.prev();
        },
        handleCalendarChange(calendar) {
            this.calendarRange = calendar;
            this.fetchEvents(calendar);
        },
        handleRefresh() {
            this.fetchEvents(this.calendarRange);
        },
        async fetchEvents(calendar) {
            this.clearErrors();
            // 1. Initialize Variables.
            // const events = [];
            const range = { start: calendar.start.date, end: calendar.end.date };

            try {
                this.loading = true;
                const resp = await getSalesSchedules(range);
                this.loading = false;
                this.schedules = resp.data;
    
            } catch (error) {
                let message = error.response ? error.response.data.message : error;
                this.setError(message);
                this.loading = false;
            }

            this.mapEvents();

            // data.forEach(each => {
            //     if(!each.pump) each.pump = NO_PUMP_LABEL;
            //     events.push(this.mapSalesSchedulesToEvent(each))
            // });
    
            // this.events = events;       
        },
        mapEvents() {
            this.events = [];
            
            this.schedules.forEach(each => {
                if(!each.pump) each.pump = NO_PUMP_LABEL;
                this.events.push(this.mapSalesSchedulesToEvent(each))
            });
        },
        renderColor(stateId) {
            let state = states.find(each => each.id == stateId);
            return state ? state.color : "black";
        },
        mapSalesSchedulesToEvent(schedule) {
            return {
                ...schedule,
                name     : schedule.customer,
                start    : schedule.start_at,
                end      : schedule.end_at,
                category : schedule[this.category],
                color    : this.renderColor(schedule.state_id),
            };
        },
        viewDay({date}) {
            this.$router.push({ path: "/sales/scheduling/report", query: { date } });
            // this.focus = date;
            // this.type = "day";
        },
        handleEventClick({event}) {
            let schedule = this.schedules.find(each => each.id == event.id);
            this.selectedEvent = schedule;
            this.eventDisplayDialog = true;
        },
        handleEventSubmit(message, type) {
            this.fetchEvents(this.calendarRange)
            let color = type === "success" ? "green" : "red";
            this.showAlert(message, color);
            if(type === "success") this.eventEditShown = false;
        },
        showAlert(message, color) {
            this.snackbar = { text: message, color, display: true};
        },
        setError(message) {
            this.errors.push(message);
            this.showAlert(message, "error");
        },
        clearErrors() {
            this.errors.splice(0, this.errors.length);
        },
        handleEventCreate() {
            this.selectedEvent = {};
            this.eventEditShown = true
        },
        handleSchedulingReport() {
            this.$router.push({ path: "scheduling/report", query: { date: this.focus } });
        },
        fetchPumps() {
            getPumps().then(resp => this.pumps = map(resp.data, 'name'));
        }
    },
    mounted () {
      this.$refs.calendar.checkChange();
      this.fetchPlants();
      this.fetchPumps();
    },
}
</script>

<style>

</style>